import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = BACKEND_URL ? `${BACKEND_URL.replace(/\/$/, "")}/api` : "/api";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token from localStorage as a fallback (works alongside cookies)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("inbox_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
    if (config.url?.includes("emails") && !config.url?.includes("analytics")) {
      console.debug(`[API] ${config.method?.toUpperCase()} ${config.url} with Authorization header`);
    }
  } else if (config.url?.includes("emails") && !config.url?.includes("analytics")) {
    console.warn(`[API] No inbox_token found for ${config.method?.toUpperCase()} ${config.url}`);
  }
  return config;
});

export default api;

export async function deleteSingleEmail(emailId) {
  try {
    console.debug(`[API] DELETE /emails/${emailId} with token=${localStorage.getItem("inbox_token") ? "set" : "missing"}`);
    const res = await api.delete(`/emails/${emailId}`);
    return res.data;
  } catch (err) {
    // Log detailed failure info for debugging
    console.error(`[API] DELETE /emails/${emailId} failed:`, {
      status: err?.response?.status,
      statusText: err?.response?.statusText,
      detail: err?.response?.data?.detail,
      hasToken: !!localStorage.getItem("inbox_token"),
      message: err?.message,
    });
    // Normalize network / axios errors so callers can show useful messages
    const e = new Error(err?.message || "Network Error");
    e.name = err?.name;
    e.code = err?.code;
    e.response = err?.response;
    throw e;
  }
}

export async function archiveSingleEmail(emailId) {
  try {
    console.debug(`[API] POST /emails/archive email_id=${emailId} with token=${localStorage.getItem("inbox_token") ? "set" : "missing"}`);
    const res = await api.post(`/emails/archive`, { email_ids: [emailId] });
    return res.data;
  } catch (err) {
    console.error(`[API] POST /emails/archive failed:`, {
      status: err?.response?.status,
      statusText: err?.response?.statusText,
      detail: err?.response?.data?.detail,
      hasToken: !!localStorage.getItem("inbox_token"),
      message: err?.message,
    });
    const e = new Error(err?.message || "Network Error");
    e.name = err?.name;
    e.code = err?.code;
    e.response = err?.response;
    throw e;
  }
}

// -----------------------------
// Bulk Delete Pass (one-time)
// -----------------------------
export async function createBulkDeleteCheckout(inboxCount) {
  const res = await api.post("/payments/checkout/pass", {
    inbox_count: inboxCount,
    origin_url: window.location.origin,
  });
  return res.data; // { url, session_id }
}

// -----------------------------
// Subscription (recurring)
// -----------------------------
export async function createSubscriptionCheckout(planId) {
  const res = await api.post("/payments/checkout/subscription", {
    plan_id: planId,
    origin_url: window.location.origin,
  });
  return res.data; // { url, session_id }
}

// -----------------------------
// Effective feature access
// -----------------------------
export async function getMyAccess() {
  const res = await api.get("/payments/access");
  return res.data;
}

// -----------------------------
// Error Formatter
// -----------------------------
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
